<script setup lang="ts">
import { ref } from '#imports'
import MoreOperationIcon from '@/components/icons/MoreOperationIcon.vue'
import { useElementSize } from '@vueuse/core'

const { registerGroups = [] } = defineProps<{
  registerGroups?: string[]
}>()

const popoverRef = ref()
const contentRef = ref()
const { height } = useElementSize(contentRef)

const handleClosePopover = () => {
  popoverRef.value?.hide?.()
}
</script>

<template>
  <ElPopover
    ref="popoverRef"
    trigger="click"
    popper-class="header-operation-container-popper"
    width="208px"
    :offset="0"
  >
    <!-- 触发 Popover 显示的 HTML 元素 -->
    <template #reference>
      <a
        class="pp-link-button"
        style="width: 48px"
      >
        <MoreOperationIcon />
      </a>
    </template>
    <!-- Popover 内嵌 HTML 文本 -->
    <div
      class="outside-click-wrapper"
      @click.stop="handleClosePopover"
    />
    <div
      class="wrapper"
      :style="{ height: `min(${height}px, calc(100vh - 38px - var(--all-header-height)))` }"
    >
      <ElScrollbar>
        <div
          ref="contentRef"
          class="content"
        >
          <template v-for="groupName in registerGroups">
            <div
              v-if="$slots[groupName]"
              :key="groupName"
              class="group"
            >
              <slot
                :name="groupName"
                class="group-item"
                @click="handleClosePopover"
              />
            </div>
          </template>
        </div>
      </ElScrollbar>
    </div>
  </ElPopover>
</template>

<style lang="less">
.outside-click-wrapper {
  position: fixed;
  inset: 0;
  z-index: 1;
}

.header-operation-container-popper {
  padding: 8px 0 !important;
  outline: 0.5px solid #98a2ad66;
  box-shadow: 0 4px 16px 0 #00000014 !important;
  border-radius: 8px !important;

  .wrapper {
    position: relative;
    z-index: 2;
    overflow: hidden;

    .content {
      .group::after {
        display: block;
        content: '';
        width: 100%;
        height: 8px;
        background-color: #f2f3f4;
      }
      .group:last-child::after {
        display: none;
      }

      .group-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 0 16px;
        min-height: 40px;
      }
    }
  }
}
</style>
